import CSRFTokenResolver from "../global/CSRFTokenResolver";

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from "laravel-echo";
import SplitType from "split-type";
import imagesLoaded from 'imagesloaded';

window.Pusher = require('pusher-js');

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: '2f56877bc7388f6893bf',
    cluster: 'eu',
    encrypted: true,
    namespace: 'Modules.Member.Events.LiveChat'
});

window.axios = require('axios');

window.axios.defaults.headers.common = {
    'X-CSRF-TOKEN': CSRFTokenResolver.getToken(),
    'X-Requested-With': 'XMLHttpRequest'
};

window.Echo.connector.pusher.connection.bind('connected', function () {
    window.axios.defaults.headers.common['X-Socket-ID'] = window.Echo.socketId();
});

var loadingManager = new THREE.LoadingManager();

// $(document).ready(function() {
    var primaryColour = $('#primary_colour').val();
    var secondaryColour = $('#secondary_colour').val();
    var accentColour = $('#accent_colour').val();
    var floorColour = $('#floor_colour').val();
    var hotspotColour = $('#hotspot_colour').val();
    var bannerURL = $('#banner_url').val();
    var bookStandBook1URLs = $('#book_stand_url').val();
    var screenUrl = $('#screen_url').val();
    var logoURL = $('#logo_url').val();
    var bannerBaseColour = floorColour || secondaryColour;

    let textureLoader = new THREE.TextureLoader(loadingManager);

    // RENDERER
    const canvas = document.getElementById('stand');
    let renderer;
    if (canvas) {
        // RENDERER
        renderer = new THREE.WebGLRenderer({
            antialias: true,
            alpha: true,
            canvas: canvas,
            powerPreference: 'high-performance'
        });
    } else {
        // RENDERER
        renderer = new THREE.WebGLRenderer({
            antialias: true,
            alpha: true,
            powerPreference: 'high-performance'
        });

        let container = document.getElementsByClassName('exhibitions-home');
        if (container.length > 0) {
            container[0].prepend(renderer.domElement);
        } else {
            document.body.prepend(renderer.domElement);
        }
    }

    const isMicrositeBoothPage = (document.getElementsByClassName('microsite').length > 0) ? true : false;

    let width = window.innerWidth,
        height = window.innerHeight;

    if (isMicrositeBoothPage) {
        height = window.innerHeight - 112;
    }

    renderer.setClearColor(0xe5e5e5);
    renderer.setPixelRatio(window.devicePixelRatio);
    renderer.setSize(width, height);
    renderer.shadowMap.enabled = true;
    renderer.physicallyCorrectLights = true;
    // renderer.shadowMap.type = THREE.PCFShadowMap; // THREE.PCFSoftShadowMap
    renderer.shadowMap.type = THREE.PCFSoftShadowMap;
    renderer.toneMapping = THREE.ACESFilmicToneMapping;
    renderer.toneMappingExposure = 0.25;
    renderer.outputEncoding = THREE.sRGBEncoding;
    THREE.Cache.enabled = true;

    // CAMERA
    let camera = new THREE.PerspectiveCamera(29.979213154087123, 1.6666666269302368, 0.009999999776482582, 10000000000);

    camera.position.set(-5, 1.5, 10);

    // SCENE
    const scene = new THREE.Scene();
    let bgTexture = textureLoader.load('/images/model-background.jpg');
    scene.background = bgTexture;
    // scene.background = new THREE.TextureLoader().load('/images/scene-bg.jpg');

    // LIGHTS
    const lightAmbient = new THREE.AmbientLight(0xffffff, 1.25);
    const lightDirectional = new THREE.DirectionalLight(0xffffff, 5);
    const lightDirectional2 = new THREE.DirectionalLight(0xffffff, 7.5);

    lightDirectional.castShadow = true;
    lightDirectional2.castShadow = true;

    lightDirectional.shadow.mapSize.width = 512;
    lightDirectional2.shadow.mapSize.width = 512;
    lightDirectional.shadow.mapSize.height = 512;
    lightDirectional2.shadow.mapSize.height = 512;
    lightDirectional.shadow.camera.near = 0.5;
    lightDirectional2.shadow.camera.near = 0.5;
    lightDirectional.shadow.camera.far = 500;
    lightDirectional2.shadow.camera.far = 500;

    lightDirectional.position.set(-6, 3, 3);
    lightDirectional2.position.set(3, 6, 6);

    // ADD LIGHTS TO THE SCENE
    scene.add(lightAmbient);
    scene.add(lightDirectional);
    scene.add(lightDirectional2);

    let controls = new THREE.OrbitControls(camera, renderer.domElement);

    function render() {
        if (objectCir) {
            objectCir.rotation.y = controls.getAzimuthalAngle();
        }

        if (vLine) {
            vLine.rotation.y = controls.getAzimuthalAngle();
        }

        if (hLine) {
            hLine.rotation.y = controls.getAzimuthalAngle();
        }

        if (objectCir2) {
            objectCir2.rotation.y = controls.getAzimuthalAngle();
        }

        if (vLine2) {
            vLine2.rotation.y = controls.getAzimuthalAngle();
        }

        if (hLine2) {
            hLine2.rotation.y = controls.getAzimuthalAngle();
        }

        if (objectCir3) {
            objectCir3.rotation.y = controls.getAzimuthalAngle();
        }

        if (vLine3) {
            vLine3.rotation.y = controls.getAzimuthalAngle();
        }

        if (hLine3) {
            hLine3.rotation.y = controls.getAzimuthalAngle();
        }
        
        if (objectCir4) {
            objectCir4.rotation.y = controls.getAzimuthalAngle();
        }

        if (vLine4) {
            vLine4.rotation.y = controls.getAzimuthalAngle();
        }

        if (hLine4) {
            hLine4.rotation.y = controls.getAzimuthalAngle();
        }
        
        if (vLine5) {
            vLine5.rotation.y = controls.getAzimuthalAngle();
        }

        if (hLine5) {
            hLine5.rotation.y = controls.getAzimuthalAngle();
        }
        
        if (objectCir5) {
            objectCir5.rotation.y = controls.getAzimuthalAngle();
        }
    }

    controls.enabled = true;
    controls.enablePan = true;
    controls.target.set(0, 1.25, -0.2);
    controls.minDistance = 5;
    controls.maxDistance = 10;
    controls.rotateSpeed = 0.5;
    controls.maxPolarAngle = Math.PI / 2;
    controls.minPolarAngle = Math.PI / 2;
    controls.minAzimuthAngle = -1.212611986159712;
    controls.maxAzimuthAngle = -0.013094791152698045;
    controls.update();

    controls.addEventListener('change', render, false);

    const loader = new GLTFLoader(loadingManager);

    let objectCir;
    let objectCir2;
    let objectCir3;
    let objectCir4;
    let objectCir5;
    let vLine;
    let hLine;
    let vLine2;
    let hLine2;
    let vLine3;
    let hLine3;
    let vLine4;
    let hLine4;
    let vLine5;
    let hLine5;
    let hotspotGroup;
    let hotspotGroup2;
    let hotspotGroup3;
    let hotspotGroup4;
    let hotspotGroup5;

    let jobsPopup = document.getElementById('jobs');

    let spotLightsPositions = [
        [-0.325, 1.825, 0.63], [-0.625, 1.825, 0.63], [-0.925, 1.825, 0.63], [ -1.225, 1.825, 0.63], 
        [-0.325, 1.825, -0.2], [-0.625, 1.825, -0.2], [-0.925, 1.825, -0.2], [-1.225, 1.825, -0.2],
        [-0.325, 1.825, -0.85], [-0.625, 1.825, -0.85], [-0.925, 1.825, -0.85], [-1.225, 1.825, -0.85],
    ];

    const interaction = new THREE.Interaction(renderer, scene, camera);

    loader.load('/js/exhibitions/models/silver-stand.glb', function (gltf) {

        for (var i = 0; i < gltf.scene.children.length; i++) {
            if (gltf.scene.children[i].children.length > 0) {
                for (var j = 0; j < gltf.scene.children[i].children.length; j++) {
                    gltf.scene.children[i].children[j].castShadow = true;
                    gltf.scene.children[i].children[j].receiveShadow = true;
                }
            }
        }
        
        gltf.scene.children[0].children[4].children[1].visible = false;
        
        gltf.scene.children[0].children[3].children[0].visible = false;

        let index = 0;
        for (var x = 0; x < gltf.scene.children[0].children[5].children.length; x++) {
            let spotLight = new THREE.SpotLight(0xffffff);
            spotLight.position.set(spotLightsPositions[index][0], spotLightsPositions[index][1], spotLightsPositions[index][2]);
            spotLight.castShadow = true;
            let object3D = new THREE.Object3D();
            object3D.position.set(spotLightsPositions[index][0], 0, spotLightsPositions[index][2]);
            scene.add(object3D);
            spotLight.target = object3D;
            scene.add(spotLight);
            index++;
        }

        if (bannerURL) {
            new THREE.TextureLoader(loadingManager).load(
                bannerURL,
                function (texture) {
                    if (gltf.scene.children[0].children[0].children[0].traverse(function (child) {
                        if (child.isMesh) {
                            child.material = new THREE.MeshPhongMaterial({
                                color: 0xffffff,
                                map: texture
                            });
                        }
                    }));
                }
            );
        }

        if (primaryColour) {
            // Table
            if (gltf.scene.children[0].children[13].traverse(function(child) {
                if (child.isMesh) {
                    child.material.color = new THREE.Color(primaryColour);
                }
            }));

            if (gltf.scene.children[0].children[12].traverse(function(child) {
                if (child.isMesh) {
                    child.material.color = new THREE.Color(primaryColour);
                }
            }));
        }

        if (secondaryColour) {
            if (gltf.scene.children[0].children[2].children[0].children[1].traverse(function(child) {
                if (child.isMesh) {
                    child.material.color = new THREE.Color(secondaryColour);
                }
            }));
        }

        if (accentColour) {
            if (gltf.scene.children[0].children[2].children[4].children[0].traverse(function (child) {
                if (child.isMesh) {
                    child.material.color = new THREE.Color(accentColour);
                }
            }));
        }

        if (logoURL) {
            if (gltf.scene.children[0].children[11].traverse(function(child) {
                if (child.isMesh) {
                    let logoHolderGeometry = new THREE.BoxGeometry(1.27, 0.36, 0.001);
                    let logoImage = textureLoader.load(logoURL);
                    let logoHolderMaterial = new THREE.MeshBasicMaterial({map: logoImage, color: new THREE.Color('#FFFFFF')});
                    logoHolderMaterial.transparent = false;
                    logoHolderMaterial.opacity = 1;
                    let logoHolderMesh = new THREE.Mesh(logoHolderGeometry, logoHolderMaterial);
                    logoHolderMesh.position.set(0.3405, 1.61, 0.52);
                    scene.add(logoHolderMesh);
                }
            }));
        }

        if (floorColour) {
            // TV Frame and Floor
            if (gltf.scene.children[0].children[2].children[4].children[1].traverse(function (child) {
                if (child.isMesh) {
                    child.material.color = new THREE.Color(floorColour);
                }
            }));
        }

        gltf.scene.children[0].children[10].scale.x += 5;
        gltf.scene.children[0].children[10].scale.z += 5;
        gltf.scene.children[0].children[10].castShadow = false;
        gltf.scene.children[0].children[10].receiveShadow = false;
        gltf.scene.children[0].children[10].visible = false;

        if (bookStandBook1URLs) {
            var cover = new THREE.TextureLoader(loadingManager).load(bookStandBook1URLs);
            for (let k = 0; k < gltf.scene.children[0].children[1].children[0].children.length; k++) {
                if (gltf.scene.children[0].children[1].children[0].children[k].traverse(function (child) {
                    if (child.isMesh) {
                        child.material = new THREE.MeshBasicMaterial({
                            color: 0xffffff,
                            map: cover
                        });
                    }
                }));
            }
        }

        if (screenUrl) {
            let tvWallpaper = textureLoader.load(screenUrl);
            let tv = new THREE.Mesh(new THREE.BoxBufferGeometry(1, 0.5, 0.001), new THREE.MeshPhongMaterial({color: 0xffffff, map: tvWallpaper}));
            tv.position.set(-0.675, 1.315, -1.299999);
            scene.add(tv);
        }

        gltf.scene.children[0].children[4].children[1].visible = false;

        scene.add(gltf.scene);

    }, function (progress) {
        if (progress.loaded === progress.total) {
            var geometryCir = new THREE.CircleBufferGeometry( 0.1, 32 );
            var materialCir = new THREE.MeshPhongMaterial( { color: hotspotColour, side: THREE.DoubleSide } );
            hotspotGroup = new THREE.Group();
            objectCir = new THREE.Mesh( geometryCir, materialCir );
            objectCir.position.set(-1.765, 1, 0.92);
            objectCir.rotation.y = controls.getAzimuthalAngle();
            
            // objectCir.sizeAttenuation = false;
            vLine = new THREE.Mesh(new THREE.BoxBufferGeometry(0.12, 0.015, 0.01), new THREE.MeshBasicMaterial({color: 0x142455}));
            hLine = new THREE.Mesh(new THREE.BoxBufferGeometry(0.015, 0.12, 0.01), new THREE.MeshBasicMaterial({color: 0x142455}));
            vLine.position.set(-1.765, 1, 0.92);
            hLine.position.set(-1.765, 1, 0.92);
            vLine.scale.x = 0.5;
            vLine.scale.y = 0.5;
            hLine.scale.x = 0.5;
            hLine.scale.y = 0.5;
            vLine.rotation.y = controls.getAzimuthalAngle();
            hLine.rotation.y = controls.getAzimuthalAngle();
            hotspotGroup.add(objectCir);
            hotspotGroup.add(vLine);
            hotspotGroup.add(hLine);
            scene.add(hotspotGroup);

            hotspotGroup2 = new THREE.Group();
            objectCir2 = new THREE.Mesh( geometryCir, materialCir );
            objectCir2.position.set(-1.35, 1.25, -1.3);
            objectCir2.rotation.y = controls.getAzimuthalAngle();
            vLine2 = new THREE.Mesh(new THREE.BoxBufferGeometry(0.12, 0.015, 0.01), new THREE.MeshBasicMaterial({color: 0x142455}));
            hLine2 = new THREE.Mesh(new THREE.BoxBufferGeometry(0.015, 0.12, 0.01), new THREE.MeshBasicMaterial({color: 0x142455}));
            vLine2.position.set(-1.35, 1.25, -1.3);
            hLine2.position.set(-1.35, 1.25, -1.3);
            vLine2.scale.x = 0.5;
            vLine2.scale.y = 0.5;
            hLine2.scale.x = 0.5;
            hLine2.scale.y = 0.5;
            vLine2.rotation.y = controls.getAzimuthalAngle();
            hLine2.rotation.y = controls.getAzimuthalAngle();
            hotspotGroup2.add(objectCir2);
            hotspotGroup2.add(vLine2);
            hotspotGroup2.add(hLine2);
            scene.add(hotspotGroup2);
            
            hotspotGroup3 = new THREE.Group();
            objectCir3 = new THREE.Mesh( geometryCir, materialCir );
            objectCir3.position.set(1.9, 1.25, 1.5);
            objectCir3.rotation.y = controls.getAzimuthalAngle();
            vLine3 = new THREE.Mesh(new THREE.BoxBufferGeometry(0.12, 0.015, 0.01), new THREE.MeshBasicMaterial({color: 0x142455}));
            hLine3 = new THREE.Mesh(new THREE.BoxBufferGeometry(0.015, 0.12, 0.01), new THREE.MeshBasicMaterial({color: 0x142455}));
            vLine3.position.set(1.9, 1.25, 1.5);
            hLine3.position.set(1.9, 1.25, 1.5);
            vLine3.scale.x = 0.5;
            vLine3.scale.y = 0.5;
            hLine3.scale.x = 0.5;
            hLine3.scale.y = 0.5;
            vLine3.rotation.y = controls.getAzimuthalAngle();
            hLine3.rotation.y = controls.getAzimuthalAngle();
            hotspotGroup3.add(objectCir3);
            hotspotGroup3.add(vLine3);
            hotspotGroup3.add(hLine3);
            scene.add(hotspotGroup3);
            
            hotspotGroup4 = new THREE.Group();
            objectCir4 = new THREE.Mesh( geometryCir, materialCir );
            objectCir4.position.set(0.25, 2, 0.75);
            objectCir4.rotation.y = controls.getAzimuthalAngle();
            vLine4 = new THREE.Mesh(new THREE.BoxBufferGeometry(0.12, 0.015, 0.01), new THREE.MeshBasicMaterial({color: 0x142455}));
            hLine4 = new THREE.Mesh(new THREE.BoxBufferGeometry(0.015, 0.12, 0.01), new THREE.MeshBasicMaterial({color: 0x142455}));
            vLine4.position.set(0.25, 2, 0.75);
            hLine4.position.set(0.25, 2, 0.75);
            vLine4.scale.x = 0.5;
            vLine4.scale.y = 0.5;
            hLine4.scale.x = 0.5;
            hLine4.scale.y = 0.5;
            vLine4.rotation.y = controls.getAzimuthalAngle();
            hLine4.rotation.y = controls.getAzimuthalAngle();
            hotspotGroup4.add(objectCir4);
            hotspotGroup4.add(vLine4);
            hotspotGroup4.add(hLine4);
            scene.add(hotspotGroup4);

            hotspotGroup.cursor = "pointer";
            hotspotGroup2.cursor = "pointer";
            hotspotGroup3.cursor = "pointer";
            hotspotGroup4.cursor = "pointer";

            function closeAllPopups() {
                $('.popup-card').removeClass('visible');
            }

            hotspotGroup.on('mouseover', function(event) {
                $('.tooltip').text('Brochures');
                $('.tooltip').show();
            });
            
            hotspotGroup.on('mouseout', function(event) {
                $('.tooltip').hide();
            });
            
            hotspotGroup2.on('mouseover', function(event) {
                $('.tooltip').text('Video');
                $('.tooltip').show();
            });
            
            hotspotGroup2.on('mouseout', function(event) {
                $('.tooltip').hide();
            });
            
            hotspotGroup3.on('mouseover', function(event) {
                $('.tooltip').text('Banner Artwork');
                $('.tooltip').show();
            });
            
            hotspotGroup3.on('mouseout', function(event) {
                $('.tooltip').hide();
            });
            
            hotspotGroup4.on('mouseover', function(event) {
                $('.tooltip').text('Introduction');
                $('.tooltip').show();
            });
            
            hotspotGroup4.on('mouseout', function(event) {
                $('.tooltip').hide();
            });
            
            hotspotGroup.on('touchstart', function(event) {
                closeAllPopups();

                if ($('#brochures')) {
                    if (!$('#brochures').hasClass('visible')) {
                        $('#brochures').addClass('visible');
                    }
                }
            });

            hotspotGroup.on('click', function(event) {
                closeAllPopups();

                if ($('#brochures')) {
                    if (!$('#brochures').hasClass('visible')) {
                        $('#brochures').addClass('visible');
                        // anime({
                        // 	targets: '#brochures',
                        // 	right: '0%',
                        // 	duration: 750,
                        // 	easing: 'easeOutExpo',
                        // 	delay: 0,
                        // 	begin: function(anim) {
                        // 		for (var i = 0; i < anim.animatables.length; i++) {
                        // 			anim.animatables[i].target.style.display = 'block';
                        // 		}
                        // 	},
                        // 	complete: function(anim) {
                        // 		for (var i = 0; i < anim.animatables.length; i++) {
                        // 			anim.animatables[i].target.classList.add('visible');
                        // 			anim.animatables[i].target.style.display = 'block';
                        // 		}
                        // 	}
                        // });
                    }
                }
            });

            $(document).on('click', 'button.close-popup', function(event) {
                event.preventDefault();
                let id = $(this).parent().parent().prop('id');

                if (id === 'popup-3d-tours') {
                    return;
                }

                if ($('#' + id).hasClass('visible')) {
                    $('#' + id).removeClass('visible');
                    // anime({
                    // 	targets: '#' + id,
                    // 	right: '-100%',
                    // 	easing: 'easeInExpo',
                    // 	duration: 500,
                    // 	complete: function(anim) {
                    // 		for (var i = 0; i < anim.animatables.length; i++) {
                    // 			anim.animatables[i].target.style.display = 'none';
                    // 			anim.animatables[i].target.classList.remove('visible');
                    // 		}
                    // 	}
                    // });
                }
            });
            
            hotspotGroup2.on('touchstart', function(event) {
                closeAllPopups();
                
                if ($('#video').length) {
                    if (!$('#video').hasClass('visible')) {
                        $('#video').addClass('visible');
                    }
                }
            });
            
            hotspotGroup2.on('click', function(event) {
                closeAllPopups();
                
                if ($('#video').length) {
                    if (!$('#video').hasClass('visible')) {
                        $('#video').addClass('visible');
                    }
                }
            });
            
            hotspotGroup3.on('touchstart', function(event) {
                closeAllPopups();
                
                if ($('#banner-artwork').length > 0) {
                    if (!$('#banner-artwork').hasClass('visible')) {
                        $('#banner-artwork').addClass('visible');
                    }
                }
            });

            hotspotGroup3.on('click', function(event) {
                closeAllPopups();
                
                if ($('#banner-artwork').length > 0) {
                    if (!$('#banner-artwork').hasClass('visible')) {
                        $('#banner-artwork').addClass('visible');
                        // anime({
                        // 	targets: '#banner-artwork',
                        // 	right: '0%',
                        // 	duration: 750,
                        // 	easing: 'easeOutExpo',
                        // 	delay: 0,
                        // 	begin: function(anim) {
                        // 		for (var i = 0; i < anim.animatables.length; i++) {
                        // 			anim.animatables[i].target.style.display = 'block';
                        // 		}
                        // 	},
                        // 	complete: function(anim) {
                        // 		for (var i = 0; i < anim.animatables.length; i++) {
                        // 			anim.animatables[i].target.classList.add('visible');
                        // 			anim.animatables[i].target.style.display = 'block';
                        // 		}
                        // 	}
                        // });
                    }
                }
            });
            
            hotspotGroup4.on('touchstart', function(event) {
                if ($('#introduction').length) {
                    if (!$('#introduction').hasClass('visible')) {
                        $('#introduction').addClass('visible');
                    }
                }
            });
            
            hotspotGroup4.on('click', function(event) {
                if ($('#introduction').length) {
                    if (!$('#introduction').hasClass('visible')) {
                        $('#introduction').addClass('visible');
                    }
                }
            });

            if (jobsPopup) {
                hotspotGroup5 = new THREE.Group();
                objectCir5 = new THREE.Mesh( geometryCir, materialCir );
                objectCir5.position.set(0.65, 0.85, -0.25);
                objectCir5.rotation.y = controls.getAzimuthalAngle();
                vLine5 = new THREE.Mesh(new THREE.BoxBufferGeometry(0.12, 0.015, 0.01), new THREE.MeshBasicMaterial({color: 0x142455}));
                hLine5 = new THREE.Mesh(new THREE.BoxBufferGeometry(0.015, 0.12, 0.01), new THREE.MeshBasicMaterial({color: 0x142455}));
                vLine5.position.set(0.65, 0.85, -0.25);
                hLine5.position.set(0.65, 0.85, -0.25);
                vLine5.scale.x = 0.5;
                vLine5.scale.y = 0.5;
                hLine5.scale.x = 0.5;
                hLine5.scale.y = 0.5;
                vLine5.rotation.y = controls.getAzimuthalAngle();
                hLine5.rotation.y = controls.getAzimuthalAngle();
                hotspotGroup5.add(objectCir5);
                hotspotGroup5.add(vLine5);
                hotspotGroup5.add(hLine5);
                scene.add(hotspotGroup5);
                hotspotGroup5.cursor = "pointer";

                hotspotGroup5.on('mouseover', function (event) {
                    $('.tooltip').text('Jobs');
                    $('.tooltip').show();
                });
    
                hotspotGroup5.on('mouseout', function (event) {
                    $('.tooltip').hide();
                });

                hotspotGroup5.on('click', function (event) {
                    if ($('#jobs').length) {
                        if (!$('#jobs').hasClass('visible')) {
                            $('#jobs').addClass('visible');
                        }
                    }
                });
                
                hotspotGroup5.on('touchstart', function (event) {
                    if ($('#jobs').length) {
                        if (!$('#jobs').hasClass('visible')) {
                            $('#jobs').addClass('visible');

                            // anime({
                            //     targets: '#jobs',
                            //     translateX: ['-101%', '0%'],
                            //     easing: 'easeInExpo',
                            //     duration: 500,
                            //     complete: function(anim) {
                            //         for (var i = 0; i < anim.animatables.length; i++) {
                            //             anim.animatables[i].target.style.display = 'none';
                            //             anim.animatables[i].target.classList.remove('visible');
                            //         }
                            //     }
                            // });
                        }
                    }
                });
            }
        }
    }, function (error) {
        console.error('Error:', error);
    });

    renderer.render(scene, camera);

    function onWindowResize() {
        width = window.innerWidth;
        if (isMicrositeBoothPage) {
            height = window.innerHeight - 112;
        } else {
            height = window.innerHeight;
        }
        camera.aspect = width / height;
        camera.updateProjectionMatrix();
        renderer.setSize(width, height);
        renderer.render(scene, camera);
    }

    window.addEventListener('resize', onWindowResize, false);

    function animate() {
        requestAnimationFrame(animate);

        controls.update();

        renderer.render(scene, camera);
    }

    animate();

    $(document).on('mousemove', function(event) {
        $('.tooltip').css('top', event.clientY)
        $('.tooltip').css('left', event.clientX)
    });

    // $(document).on('click', '#expand-menu', function(event) {
    //     event.preventDefault();

    //     if ($('#side-nav').hasClass('collapsed')) {
    //         $('#side-nav').removeClass('collapsed');
    //     }
    // });

    // $(document).on('click', '#collapse-menu', function(event) {
    //     event.preventDefault();

    //     if (!$('#side-nav').hasClass('collapsed')) {
    //         $('#side-nav').addClass('collapsed');
    //     }
    // });

    $(document).on('click', '.accordion-item', function(event) {
        event.preventDefault();

        $('.accordion-body').slideUp();
        $(this).find('.accordion-body').slideDown(300);
    });

    $(document).on('click', '#fab-chat', function(event) {
        event.preventDefault();
        $(this).hide();
        $('#chat-popup').addClass('visible');
    });

    $(document).on('click', '#chat-btn', function(event) {
        event.preventDefault();
        $('#fab-chat').hide();
        $('#chat-popup').addClass('visible');
    });

    $(document).on('click', '#greeting_video_toggle', function(event) {
        event.preventDefault();

        $('#greeting-video').addClass('visible');
    });

    var loadedPercentage = 0;
    var counter = 0;
    var target = 0;

    var loaded = false;

    loadingManager.onProgress = function(item, progress, total) {
        var progressBar = document.getElementById('progress');
        var progressText = document.getElementById('progress-text');
        if (progressBar) {
            loadedPercentage = Math.max(loadedPercentage, progress / total * 100);
            target = parseInt(loadedPercentage);
            let difference = Math.max(50, target - counter);
            function animate() {
                if (counter < target) {
                    counter++;
                    progressBar.style.width = counter + '%';
                    if (progressText) {
                        progressText.innerHTML = counter + '<small class="percent__sign">%</small>';
                    }
                } else {
                    clearInterval(id)
                }
            }
            var id = setInterval(animate, 10);
        }
    };

    loadingManager.onLoad = function() {
        var loadingScreen = document.getElementById('loading-screen');
        if (loadingScreen) {
            window.setTimeout(function() {
                loadingScreen.style.top = '-100vh';
                loaded = true;

                if (loaded) {
                    window.setTimeout(function() {
                        loadingScreen.style.display = 'none';
                    }, 2000);
                }
            }, 1000);
        }
    };
// });

$(document).on('click', '#expand-menu', function(event) {
    event.preventDefault();

    var timeline = anime.timeline({
        easing: 'easeInOutQuad',
        duration: 500,
        direction: 'normal'
    });

    timeline.add({
        targets: '#side-nav .navigation-content',
        opacity: [1, 0],
        duration: 250,
        delay: 0,
        complete: function(anim) {
            $('#side-nav').css('display', 'none');
        }
    }).add({
        targets: '#side-nav-expanded',
        width: ['120px', '492px'],
        duration: 350,
        // delay: '+=200',
        begin: function(anim) {
            anim.animatables.forEach(function(item) {
                item.target.style.display = 'block';
            });
        }
    }, '-=50').add({
        targets: '#side-nav-expanded .navigation-content',
        opacity: [0, 1],
        duration: 300,
        // delay: '+=100',
        // easing: 'easeInOutExpo',
        begin: function(anim) {
            anim.animatables.forEach(function(item) {
                item.target.style.display = 'block';
            });
        }
    }, '-=50');

    anime({
        targets: '.content',
        width: '492px',
        easing: 'easeInOutQuad',
        duration: 500,
        delay: 50
    });

    width = window.innerWidth - 492;

    localStorage.setItem('sideMenu', 'false');
});

$(document).on('click', '#collapse-menu', function(event) {
    event.preventDefault();

    var timeline = anime.timeline({
        easing: 'easeInOutQuad',
        direction: 'normal'
    });
    
    timeline.add({
        targets: '#side-nav-expanded .navigation-content',
        opacity: 0,
        duration: 250,
        // delay: '+=200',
        begin: function(anim) {
            anim.animatables.forEach(function(item) {
                item.target.style.display = 'block';
            });
        },
        complete: function(anim) {
            anim.animatables.forEach(function(item) {
                item.target.style.display = 'none';
            });
        }
    }).add({
        targets: '#side-nav-expanded',
        width: '120px',
        duration: 350,
        begin: function(anim) {
            anim.animatables.forEach(function(item) {
                item.target.style.display = 'block';
            });
        },
        complete: function(anim) {
            anim.animatables.forEach(function(item) {
                item.target.style.display = 'none';
            });
        }
    }, '-=75').add({
        targets: '#side-nav .navigation-content',
        opacity: [0, 1],
        duration: 350,
        delay: 0,
        begin: function(anim) {
            $('#side-nav').css('display', 'block');
        }
    }, '-=50');

    var paddingLeft = $('#side-nav').prop('width');
    var offsetWidth = $('#side-nav').prop('offsetWidth');

    anime({
        targets: '.content',
        paddingLeft: paddingLeft,
        easing: 'easeInOutQuad',
        duration: 500,
        delay: 50
    });

    width = window.innerWidth - 120;

    localStorage.setItem('sideMenu', 'true');
});

var iframeInitialised = false,
    galleryInitialised = false,
    _pathname = window.location.pathname;
        
    if (_pathname && _pathname.length > 0) {
        if (_pathname[0] == '/') {
            _pathname = _pathname.replace('/', '');
        }
        
        let _pathnames = _pathname.split('/');
        _pathname = _pathnames[0];
    }

$('.btn-3d-tour').click(function(event) {
    event.preventDefault();

    if ($('#popup-3d-tours').hasClass('visible')) {
        return;
    }

    let _memberId = $('a.btn-tour__card.active').data('id') || $('a.btn-tour__card').first().data('id');
    axios.post('/' + _pathname + '/matterport/' + _memberId);

    anime({
        targets: '#popup-3d-tours',
        translateX: ['-102%', '0%'],
        duration: 750,
        easing: 'easeOutExpo',
        delay: 0,
        begin: function(anim) {
            for (var i = 0; i < anim.animatables.length; i++) {
                anim.animatables[i].target.style.display = 'block';
            }

            if (iframeInitialised) {
                $('#popup-3d-tours iframe').attr('src', $('#popup-3d-tours iframe').attr('data-src'));
            }

            if (!galleryInitialised) {
                if ($('.tours-wrapper .tours-scroll').width() < $('.tours-wrapper .tours-scroll').prop('scrollWidth')) {
                    if ($('.tours-wrapper .tours-scroll').prop('scrollLeft') < 5) {
                        $('.tours-wrapper .tours-scroll').parent().removeClass('scroll-end');
                        $('.tours-wrapper .tours-scroll').parent().addClass('scroll-start');
                    } else if (($('.tours-wrapper .tours-scroll').prop('scrollLeft') + $('.tours-wrapper .tours-scroll').width() + 5) >= $('.tours-wrapper .tours-scroll').prop('scrollWidth')) {
                        $('.tours-wrapper .tours-scroll').parent().removeClass('scroll-start');
                        $('.tours-wrapper .tours-scroll').parent().addClass('scroll-end');
                    } else {
                        $('.tours-wrapper .tours-scroll').parent().addClass('scroll-start');
                        $('.tours-wrapper .tours-scroll').parent().addClass('scroll-end');
                    }
                } else {
                    $('.tours-wrapper .tours-scroll').parent().removeClass('scroll-start');
                    $('.tours-wrapper .tours-scroll').parent().removeClass('scroll-end');
                }
                galleryInitialised = true;
            }
        },
        complete: function(anim) {
            for (var i = 0; i < anim.animatables.length; i++) {
                anim.animatables[i].target.classList.add('visible');
                anim.animatables[i].target.style.display = 'block';
                // Splits text into words and characters
                // $('#popup-3d-tours h1').css('overflow: hidden;');
                const heading = new SplitType('#popup-3d-tours h1', {
                    types: 'chars',
                    absolute: true
                });

                anime({
                    targets: heading.chars,
                    opacity: [0, 1],
                    translateY: [20, 0],
                    duration: 240,
                    easing: 'easeOutExpo',
                    delay: anime.stagger(20)
                });
            }
        }
    });
});

$('#close-3d-tours').click(function(event) {
    event.preventDefault();

    anime({
        targets: '#popup-3d-tours',
        translateX: '-101%',
        easing: 'easeInExpo',
        duration: 500,
        complete: function(anim) {
            for (var i = 0; i < anim.animatables.length; i++) {
                anim.animatables[i].target.style.display = 'none';
                anim.animatables[i].target.classList.remove('visible');
            }

            if (iframeInitialised) {
                $('#popup-3d-tours iframe').attr('src', '');
            }
        }
    });
});

$('a.btn-tour__card').click(function(event) {
    event.preventDefault();
    event.stopPropagation();

    $('a.btn-tour__card').removeClass('active');
    $(this).addClass('active');

    let _src = $(this).data('src').trim();
    $('#popup-3d-tours iframe').attr('src', _src);
    $('#popup-3d-tours iframe').attr('data-src', _src);

    let _memberId = $(this).data('id');
    axios.post('/' + _pathname + '/matterport/' + _memberId);
});

$('.tours-wrapper').imagesLoaded()
    .progress(function(instance, image) {
        if (!image.isLoaded) {
            $(image.img).closest('.tour-item').remove();
        }
    })
    .always(function(instance) {
        $('a.btn-tour__card').first().addClass('active');
        $('#popup-3d-tours iframe').attr('data-src', $('a.btn-tour__card').first().data('src'));
    });

$('#popup-3d-tours iframe').removeAttr('width');
$('#popup-3d-tours iframe').removeAttr('height');
$('#popup-3d-tours iframe').css('width', '100%');
$('#popup-3d-tours iframe').css('height', '100%');
iframeInitialised = true;

let _isMouseDown = false,
    _startX,
    _scrollLeft;

$('.tours-wrapper .tours-scroll').each((index, element) => {
    if ($(element).prop('scrollWidth') > $(element).width()) {
        if ($(element).prop('scrollLeft') > 5) {
            $(element).parent().addClass('scroll-start');
        }

        if (($(element).prop('scrollLeft') + $(element).width()) >= $(element).prop('scrollWidth')) {
            $(element).parent().addClass('scroll-end');
        }
    }

    var tabsList = element;

    $(element).parent().find('.nav-prev').on('mousedown', function(event) {
        event.preventDefault();
        $(tabsList).animate({
            scrollLeft: $(tabsList).prop('scrollLeft') - (Math.floor(($('.tours-wrapper').width() + 120) / ($('.tour-item').width() + 16)) * ($('.tour-item').width() + 16))
        }, 350);
    });
    
    $(element).parent().find('.nav-next').on('mousedown', function(event) {
        event.preventDefault();
        $(tabsList).animate({
            scrollLeft: $(tabsList).prop('scrollLeft') + (Math.floor(($('.tours-wrapper').width() + 120) / ($('.tour-item').width() + 16)) * ($('.tour-item').width() + 16))
        }, 350);
    });
});

$('.tours-wrapper .tours-scroll').on('scroll', function(event) {
    if ($(this).prop('scrollLeft') < 5) {
        $(this).parent().removeClass('scroll-end');
        $(this).parent().addClass('scroll-start');
    } else if (($(this).prop('scrollLeft') + $(this).width() + 125) >= $(this).prop('scrollWidth')) {
        $(this).parent().removeClass('scroll-start');
        $(this).parent().addClass('scroll-end');
    } else {
        $(this).parent().addClass('scroll-start');
        $(this).parent().addClass('scroll-end');
    }
});

$('.tours-wrapper .tours-scroll').on('mousedown', function(event) {
    _isMouseDown = true;
    _startX = event.pageX - $('.tours-wrapper .tours-scroll').offset().left;
    _scrollLeft = $('.tours-wrapper .tours-scroll').scrollLeft();
});

$('.tours-wrapper .tours-scroll').on('mouseleave', function(event) {
    _isMouseDown = false;
});

$('.tours-wrapper .tours-scroll').on('mouseup', function(event) {
    _isMouseDown = false;
});

$('.tours-wrapper .tours-scroll').on('mousemove', function(event) {
    event.preventDefault();
    if (!_isMouseDown) return;
    else event.stopPropagation();
    let _x = event.pageX - $('.tours-wrapper .tours-scroll').offset().left;
    let _walk = _x - _startX;
    $('.tours-wrapper .tours-scroll').scrollLeft(_scrollLeft - _walk);
});